import { render } from "./InfiniteList.vue?vue&type=template&id=00183f53&scoped=true"
import script from "./InfiniteList.vue?vue&type=script&lang=js"
export * from "./InfiniteList.vue?vue&type=script&lang=js"

import "./InfiniteList.vue?vue&type=style&index=0&id=00183f53&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00183f53"]])

export default __exports__